import 'Vendor/owlcarousel/owl.carousel.min';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { isObject } from 'Lib/is-object/is-object';

const $body = $('body');
const $slider = $('.publications_slider .publications__box');
const cSliderOn = 'owl-carousel';
const sSliderImg = '.publications__bg';

function loadPics(e) {
    onScreen(isObject(e) ? $(e.target).find(sSliderImg) : $(sSliderImg), loadSrcOrBg);
}

function setSlider() {
    if (getW() > eksmoBP.smMin) {
        $slider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    loop: true,
                    smartSpeed: speed * 2,
                    margin: 16,
                    nav: true,
                    items: 3,
                    dots: false,
                    sArrows: '.publications__arrows',
                    navClass: ['publications__prev arrow arrow_prev arrow_shadow', 'publications__next arrow arrow_next arrow_shadow'],
                    navText: ['', ''],
                    onInitialized: loadPics,
                    responsive: {
                        1200: {
                            items: 3,
                        },
                    },
                });
        });
    } else {
        $slider.trigger('destroy.owl.carousel');
    }
}

loadPics();
setSlider();
$body.on('eksmoResizeWidth', setSlider);
$body.on('eksmoPagenavAjax', loadPics);